import {
    EmployeeGroupChangeCompanyInformationDTO,
    EmployeeGroupChangeRequestDTO,
    ScheduleEmployeeGroupChangeRequest,
    UpdateEmployeeGroupChangeDateRequest
} from '@iota/inh-core-v1-management-client';
import { createAction, props } from '@ngrx/store';

export const LoadCompanyEmployeeGroupChangeInformation = createAction(
    '[EmployeeGroupChange] LoadCompanyEmployeeGroupChangeInformation',
    props<{ companyId: string }>()
);
export const LoadCompanyEmployeeGroupChangeInformationSuccess = createAction(
    '[EmployeeGroupChange] LoadCompanyEmployeeGroupChangeInformationSuccess',
    props<{ companyId: string; companyInformation: EmployeeGroupChangeCompanyInformationDTO }>()
);
export const LoadCompanyEmployeeGroupChangeInformationFailure = createAction(
    '[EmployeeGroupChange] LoadCompanyEmployeeGroupChangeInformationFailure',
    props<{ error: any }>()
);

export const LoadAllEmployeeGroupChangesByCompany = createAction(
    '[EmployeeGroupChange] LoadAllEmployeeGroupChangesByCompany',
    props<{ companyId: string }>()
);
export const LoadAllEmployeeGroupChangesByCompanySuccess = createAction(
    '[EmployeeGroupChange] LoadAllEmployeeGroupChangesByCompanySuccess',
    props<{ employeeGroupChanges: EmployeeGroupChangeRequestDTO[] }>()
);
export const LoadAllEmployeeGroupChangesByCompanyFailure = createAction(
    '[EmployeeGroupChange] LoadAllEmployeeGroupChangesByCompanyFailure',
    props<{ error: any }>()
);

export const ScheduleEmployeeGroupChange = createAction(
    '[EmployeeGroupChange] ScheduleEmployeeGroupChange',
    props<{ request: ScheduleEmployeeGroupChangeRequest }>()
);
export const ScheduleEmployeeGroupChangeSuccess = createAction(
    '[EmployeeGroupChange] ScheduleEmployeeGroupChangeSuccess',
    props<{ employeeGroupChangeRequest: EmployeeGroupChangeRequestDTO }>()
);
export const ScheduleEmployeeGroupChangeFailure = createAction(
    '[EmployeeGroupChange] ScheduleEmployeeGroupChangeFailure',
    props<{ error?: any }>()
);

export const UpdateEmployeeGroupChangeDate = createAction(
    '[EmployeeGroupChange] UpdateEmployeeGroupChangeDate',
    props<{ id: string; request: UpdateEmployeeGroupChangeDateRequest }>()
);
export const UpdateEmployeeGroupChangeDateSuccess = createAction(
    '[EmployeeGroupChange] UpdateEmployeeGroupChangeDateSuccess',
    props<{ employeeGroupChangeRequest: EmployeeGroupChangeRequestDTO }>()
);
export const UpdateEmployeeGroupChangeDateFailure = createAction(
    '[EmployeeGroupChange] UpdateEmployeeGroupChangeDateFailure',
    props<{ error?: any }>()
);

export const CancelEmployeeGroupChange = createAction('[EmployeeGroupChange] CancelEmployeeGroupChange', props<{ id: string }>());
export const CancelEmployeeGroupChangeSuccess = createAction(
    '[EmployeeGroupChange] CancelEmployeeGroupChangeSuccess',
    props<{ employeeGroupChangeRequest: EmployeeGroupChangeRequestDTO }>()
);
export const CancelEmployeeGroupChangeFailure = createAction(
    '[EmployeeGroupChange] CancelEmployeeGroupChangeFailure',
    props<{ error?: any }>()
);
